// extracted by mini-css-extract-plugin
module.exports = {"archiveContainer":"supervisorInbox_archiveContainer__2Rvur","threadContainer":"supervisorInbox_threadContainer__dRnQM","hide":"supervisorInbox_hide__2JeXN"};